import * as React from "react";
import InstitucionalContainer from "../conteiners/institucional-container";

export default function InstitucionalPage({ pagina, titulo, tituloSpan }) {
  return (
    <InstitucionalContainer
      pagina={pagina}
      titulo={titulo}
      tituloSpan={tituloSpan}
    ></InstitucionalContainer>
  );
}
